// // TOP ARTIST
// export const GETTOP_ARTIST = "GETTOP_ARTIST";
// export const GETMYTOP_ARTIST_SUCCESSFUL = "GETTOP_ARTIST_SUCESSS";
// export const GETTOP_ARTIST_FAILED = "GETTOP_ARTIST_FAILED";
// // 





// Add COLLECTION
export const POST_CUSTOM_ART = "POST_CUSTOM_ART"
export const POST_CUSTOM_ART_FAIL = "POST_CUSTOM_ART_FAIL"
export const POST_CUSTOM_ART_SUCCESS = "POST_CUSTOM_ART_SUCCESS"


export const GET_CUSTOM_ART_LIST = "GET_CUSTOM_ART_LIST"
export const GET_CUSTOM_ART_LIST_FAIL = "GET_CUSTOM_ART_LIST_FAIL"
export const GET_CUSTOM_ART_LIST_SUCCESS = "GET_CUSTOM_ART_LIST_SUCCESS"
